module.exports = __webpack_public_path__ + "media/images/icons/yen-5e4358dde27074f8c77e67129e4117b7.svg";